import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../config/config.service';
import { Balanca } from '../../../../types/Balanca.type';

@Injectable({
  providedIn: 'root'
})
export class BalancaConfigService {

  private readonly basePath = '/pesagem-balanca/balanca';

  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  findAll(instancia?: string): Observable<Balanca[]> {
    const params: any = {};
    if (instancia) params['instancia'] = instancia;
    return this.httpClient.get<Balanca[]>(`${this.configService.getApiUrlRoot()}${this.basePath}`, { params });
  }

  findById(id: string): Observable<Balanca> {
    return this.httpClient.get<Balanca>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`);
  }

  create(balanca: Balanca): Observable<Balanca> {
    return this.httpClient.post<Balanca>(`${this.configService.getApiUrlRoot()}${this.basePath}`, balanca);
  }

  update(id: string, balanca: Balanca): Observable<Balanca> {
    return this.httpClient.put<Balanca>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`, balanca);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`);
  }

}
